export enum HttpStatusEnum {
  Unauthorized = 401,
  ServerError = 500,
}
